<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

* {
  margin: 0;
}

.main {
  height: calc(100vh - 60px);
  overflow: auto;
  background-color: rgb(248, 248, 248);
}

.el-header {
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 6px 0px;
}

.el-main {
  padding: 0;
}

.login-page .el-input-group__prepend {
  padding: 0;
  border: 0;
}
.login-page .el-input-group__prepend input {
  padding-left: 36px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  /* text-align: center; */
}

.login-page input {
  height: 60px;
}

.green {
  color: #50b85c;
}

.el-button--success {
  background-color: #50b85c !important;
  border-color: #50b85c !important;
}

.el-button--success.is-plain {
  background-color: #f0f9eb !important;
  border-color: #c2e7b0 !important;
}

.el-button--success.is-plain:hover {
  background-color: #f0f9eb !important;
  border-color: #c2e7b0 !important;
  color: #50b85c;
}

.el-tag--dark.el-tag--success {
  background-color: #50b85c !important;
  border-color: #50b85c !important;
}

.el-tag--plain.el-tag--success {
  border-color: #50b85c !important;
  color: #50b85c !important;
}

.el-progress-bar__inner {
  background-color: #50b85c !important;
}

.login-page .el-radio-button__inner {
  width: 100%;
}

.login-page .el-radio-button__inner{
  height: 100%;
  line-height: 2.5em;
}

.login-page .el-radio-button__inner:hover,
.el-button--success.is-plain:focus,
.el-button--success.is-plain:active {
  color: #50b85c !important;
}

.login-page .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: #50b85c !important;
  border-color: #50b85c !important;
  color: #fff !important;
}

.el-upload {
  width: 100%;
}
.video_main .upload_box .el-upload {
  height: 100%;
  aspect-ratio: unset;
}

.el-message-box__btns .el-button--primary {
  background-color: #50b85c !important;
  border-color: #50b85c !important;
}

.ai_main .el-dialog,
.collect_main .el-dialog,
.workblank .pop_img,
.meterial_main .pop_img,
.history_main .pop_img,
.hcd_main .el-dialog {
  /* max-width: 80vw; */
  display: table;
  width: auto;
  background-color: transparent;
  border: 0;
  box-shadow: none;
  margin: 0 auto;
}

.ai_main .el-dialog.case_box {
  display: block;
  background: #fff;
}

.ai_main .el-dialog.case_box .el-dialog__header {
  padding: 20px 20px 10px;
}

.ai_main .el-dialog.case_box .el-dialog__body {
  padding: 25px 25px 30px;
}

.ai_main .el-dialog .el-dialog__header,
.collect_main .el-dialog .el-dialog__header,
.workblank .pop_img .el-dialog__header,
.hcd_main .el-dialog .el-dialog__header,
.history_main .pop_img .el-dialog__header,
.meterial_main .pop_img .el-dialog__header {
  padding: 0;
}

.ai_main .el-dialog .el-dialog__body,
.collect_main .el-dialog .el-dialog__body,
.workblank .pop_img .el-dialog__body,
.hcd_main .el-dialog .el-dialog__body,
.history_main .pop_img .el-dialog__body,
.meterial_main .pop_img .el-dialog__body {
  padding: 0;
}

.ai_main .el-radio-button__inner {
  font-size: 20px;
  font-weight: normal;
}

.ai_main .el-radio-group .el-radio-button__inner {
  border-radius: 0;
}

.ai_main .btn_save .el-button--success {
  font-size: 20px;
  font-weight: normal;
}

.ai_main .el-radio__label {
  font-size: 16px;
}

.ai_main .lexicon_box.el-dialog {
  background-color: #fff;
}

.ai_main .lexicon_box.el-dialog--center .el-dialog__body {
  padding: 25px 25px 30px;
}

.ai_main .lexicon_box .el-menu {
  background-color: transparent;
}

.ai_main .el-textarea__inner {
  padding: 30px 15px;
}

i.el-icon-like,
i.el-icon-like-on {
  width: 15px;
  height: 16px;
  background: url(./assets/ico_vote.png) no-repeat;
  background-size: auto 15px;
  background-position: 0 1px;
  vertical-align: bottom;
}
i.el-icon-like-on {
  background-image: url(./assets/ico_vote_on.png);
}

.el-radio__input.is-checked .el-radio__inner,
.el-radio-button__orig-radio:checked+.el-radio-button__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #50b85c !important;
  border-color: #50b85c !important;
}

.el-radio__input.is-checked+.el-radio__label,
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #50b85c !important;
}

.el-slider__bar {
  background-color: #50b85c !important;
}

.el-slider__button,
.el-menu--horizontal>.el-menu-item.is-active {
  border-color: #50b85c !important;
}

.workblank .add .el-icon-plus {
  display: block;
  margin-bottom: 10px;
}

.meterial_main .el-radio-button__inner {
  width: 100%;
  height: 100%;
  font-size: 20px;
  line-height: 28px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue